var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DIV",
    [
      _c("ItpText", [_vm._v(_vm._s(_vm._f("date")(_vm.item.valid_from)))]),
      _vm._v(" "),
      _vm.item.valid_to
        ? _c("ItpText", [
            _vm._v(" - " + _vm._s(_vm._f("date")(_vm.item.valid_to)))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ItpText", { staticClass: "px-3" }, [
        _vm.item.quantity != null
          ? _c("span", [
              _vm._v(
                "\n    " +
                  _vm._s(_vm._f("number")(_vm.item.quantity)) +
                  " " +
                  _vm._s(_vm.item.unit_of_quantity || "") +
                  " ×\n  "
              )
            ])
          : _vm._e(),
        _vm._v(
          "\n   " +
            _vm._s(_vm._f("number")(_vm.item.amount)) +
            " " +
            _vm._s(_vm.item.currency) +
            " [" +
            _vm._s(_vm.item.unit) +
            "]\n"
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }